import React from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';
import { FaInstagram, FaFacebook, FaHeart, FaWhatsapp } from 'react-icons/fa';
import { AiOutlineLike } from 'react-icons/ai';
import { IoMdSend } from 'react-icons/io';
import socialmedia from 'assets/socialmedia.svg';
import { ButtonSocial, H1, H4 } from './styles';

const SectionRedesSociais = () => {
  return (
    <Container className="py-5">
      <Row className="align-items-center">
        <Col md={6} className="pb-4">
          <H1>Siga-nos,</H1>
          <H4>nas redes sociais!</H4>
          <Row>
            <Col>
              <ButtonSocial
                color="#3B5998"
                href="https://www.facebook.com/saborearresto"
                target="_blank"
                without="true"
                title="Instagram"
                rel="noopener noreferrer"
              >
                <FaFacebook size={26} />
                <p className="social-nome">Facebook</p>
                <span>
                  <AiOutlineLike size={26} />
                </span>
              </ButtonSocial>
            </Col>
          </Row>
          <Row>
            <Col>
              <ButtonSocial
                href="https://www.instagram.com/saborearresto/"
                target="_blank"
                without="true"
                title="Instagram"
                rel="noopener noreferrer"
                color="linear-gradient(45deg, #f09433 0%,#e6683c 25%,#dc2743 50%,#cc2366 75%,#bc1888 100%); 
filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f09433', endColorstr='#bc1888',GradientType=1 );"
              >
                <FaInstagram size={26} />

                <p className="social-nome">Instagram</p>
                <span>
                  <FaHeart size={26} />
                </span>
              </ButtonSocial>
            </Col>
          </Row>
          <Row>
            <Col>
              <ButtonSocial
                href="https://wa.me/558896089633"
                target="_blank"
                without="true"
                title="Whatsapp"
                rel="noopener noreferrer"
                color="#4CAF50"
              >
                <FaWhatsapp size={26} />

                <p className="social-nome">Whatsapp</p>
                <span>
                  <IoMdSend size={26} />
                </span>
              </ButtonSocial>
            </Col>
          </Row>
        </Col>
        <Col xs={12} md={6} className="text-center text-md-right">
          <Image src={socialmedia} fluid />
        </Col>
      </Row>
    </Container>
  );
};

export default SectionRedesSociais;
